import { createContext } from 'react'

export const NodesContext = createContext(null)
